import { Controller } from "@hotwired/stimulus";
import { mapEditedEventName } from "../../../../../../Components/Map/MapController";
import ViewOrEditFormController from "../../../../../../Components/ViewOrEditForm/ViewOrEditFormController";

export default class GeographicalInformationController extends Controller {

    connect() {
        this.element.addEventListener(mapEditedEventName, this.onMapEdited.bind(this), {});
    }

    onMapEdited() {
        this.getViewOrEditFormController().edit();
    }

    private getViewOrEditFormController(): ViewOrEditFormController {
        return this.application.getControllerForElementAndIdentifier($("form", this.element)[0], "view-or-edit-form") as ViewOrEditFormController;
    }
}